(function($, undefined) {
  'use strict';
  var sitekey = 'YOUR_SITE_KEY';

  /* RECAPTCHA UTIL FUNCTION */
  /**
   * Render recaptchas dynamically.
   * @param   btn         An element referencing the button or a string
   *                      referencing the Id of the element.
   * @param   callback    A function to be called after recaptcha has
   *                      completed its check. The function is passed back
   *                      the recaptcha response and the form element.
   * @param   validate    (optional) A boolean to know if a form needs to be
   *                      validated using the formValidator in com/form.js.
   * @param   form        (optional) A jQuery object reference the form to be
   *                      validated using formValidator in com/form.js.
   */

  var recaptchaFct = function(btn, callback, validate, form) {
    if (btn && window.grecaptcha) {
      if (window.grecaptcha.render) {
        grecaptcha.render(btn, {
          sitekey: sitekey,
          callback: function(response) {
            var formValidator = Fw.component.models().form.validateForm;
            var validated = true;
            if (validate) {
              validated = false;
              formValidator(form);
              if (!form.hasClass('has-error')) {
                validated = true;
              }
            }

            if (validated) {
              callback(response, form);
            } else {
              grecaptcha.reset();
            }
          },
          badge: 'inline'
        });
      } else {
        setTimeout(function() {
          recaptchaFct(btn, callback, validate, form);
        }, 250);
      }
    } else if (btn && !window.grecaptcha) {
      setTimeout(function() {
        recaptchaFct(btn, callback, validate, form);
      }, 250);
    }
  };

  var recaptcha = Fw.component.export('recaptcha', {
    recaptcha: recaptchaFct
  });
})(jQuery);
